import { render, staticRenderFns } from "./customerFanliTongji.vue?vue&type=template&id=09d41d08"
import script from "./customerFanliTongji.vue?vue&type=script&lang=js"
export * from "./customerFanliTongji.vue?vue&type=script&lang=js"
import style0 from "./customerFanliTongji.vue?vue&type=style&index=0&id=09d41d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports